import {getConfig} from './Config';

/**
 * Единый адрес CTA «Обновить тариф» / «Перейти к тарифам» (QA R4/R17, 2026-09-15).
 *
 * Правило: внутри приложения любой CTA апгрейда (глобальный {@code UpgradePrompt}, инлайн-апселл
 * premium-аналитики, подсказки стилиста и т.п.) ведёт на внутреннюю страницу подписки
 * {@link UPGRADE_URL}. Наружу, на портал оплаты, ведёт только сама страница подписки —
 * через {@link getUpgradePortalUrl}. Так пользователь сначала видит свой тариф и лимиты,
 * а внешний адрес живёт в одном месте (конфиг {@code upgradePortalUrl}).
 */
export const UPGRADE_URL = '/subscription';

/**
 * Внешний портал апгрейда тарифа (deep-link из конфига {@code upgradePortalUrl}, CTHS-21).
 * Используется только страницей подписки; {@code undefined}, если портал не сконфигурирован —
 * тогда CTA наружу не показывается.
 */
export const getUpgradePortalUrl = (): string | undefined => {
    const url = getConfig('upgradePortalUrl');
    return typeof url === 'string' && url.trim() ? url : undefined;
};
